<div class="gps-search">
    <form class="form-horizontal">
        <div class="form-group">
            <div class="col-sm-4 col-md-3" *ngIf="selectSiteEnabled">
                <app-select-site [disabled]="this.searchService.searching"
                    (siteSelected)="selectSite($event)">
                </app-select-site>
            </div>
            <div class="col-sm-3 col-md-3">
                <input data-cy="latitude"
                       class="form-control"
                       [attr.disabled]="canSearch ? null : 'disabled'"
                       id="latitude"
                       min="{{ searchService.minLatitude }}"
                       max="{{ searchService.maxLatitude }}"
                       name="latitude"
                       [(ngModel)]="searchService.latitude"
                       placeholder="Latitude e.g. -33.768337"
                       [required]
                       type="number">
            </div>
            <div class="col-sm-3 col-md-3">
                <input data-cy="longitude"
                       class="form-control"
                       [attr.disabled]="canSearch ? null : 'disabled'"
                       id="longitude"
                       min="{{ searchService.minLongitude }}"
                       max="{{ searchService.maxLongitude }}"
                       name="longitude"
                       [(ngModel)]="searchService.longitude"
                       placeholder="Longitude e.g. 150.627704"
                       [required]
                       type="number">
            </div>
            <div class="col-sm-2 col-md-3">
                <button data-cy="gps-search-btn"
                        class="btn btn-success btn-block"
                        (click)="search()"
                        [disabled]="!searchService.site || !searchService.isValid() || searchService.searching || !searchService.latitude || !searchService.longitude"
                        type="button">Search
                </button>
            </div>
        </div>
    </form>

    <div class="text-center p-v-50" *ngIf="!searchService.site || !searchService.isValid() || !searchService.latitude || !searchService.longitude && !searchService.gpsLogDateGroups">
        <svg width="100" height="93" viewBox="0 0 100 93" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M 70.343 72.561 L 88.274 90.493 L 92.493 86.274 L 74.562 68.342 M 46.082 19.822 L 46.082 24.041 M 69.287 43.027 L 64.013 43.027 M 21.822 43.027 L 27.096 43.027 M 46.082 65.178 L 46.082 60.959" stroke="#D3D4D7" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2 2" style=""/>
            <circle cx="45.027" cy="43.027" r="9.493" stroke="#D3D4D7" stroke-linecap="square" stroke-linejoin="round" stroke-dasharray="2 2" style=""/>
            <circle cx="45.027" cy="43.027" r="17.931" stroke="#D3D4D7" stroke-linecap="square" stroke-linejoin="round" stroke-dasharray="2 2" style=""/>
            <circle cx="45.028" cy="43.027" r="32.699" stroke="#D3D4D7" stroke-linecap="square" stroke-linejoin="round" stroke-dasharray="2 2" style=""/>
            <circle cx="45.027" cy="43.027" r="39.027" stroke="#D3D4D7" stroke-linecap="square" stroke-linejoin="round" stroke-dasharray="2 2" style=""/>
        </svg>

        <h5>No Coordinates, yet.</h5>
        <p class="muted">Get started by selecting site.</p>
    </div>

    <app-search-result-tabs *ngIf="searchService.gpsLogDateGroups"></app-search-result-tabs>
</div>
